export { default } from './useInterval';

export type * from './types';
